import { render, staticRenderFns } from "./modelForm.vue?vue&type=template&id=07abaaa2&"
import script from "./modelForm.vue?vue&type=script&lang=js&"
export * from "./modelForm.vue?vue&type=script&lang=js&"
import style0 from "./modelForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports